// extracted by mini-css-extract-plugin
export default {"mainCont":"StaffOrderHistory_mainCont__sOma5","TableDiv":"StaffOrderHistory_TableDiv__+sef3"};